export const iconMap = {
  filledCheck: {
    name: 'visa-icon-checkmark-solid-round',
    id: 'table-icon-checkmark-solid-round-id',
  },
  emptyCheck: {
    name: 'visa-icon-checkmark-reverse-round',
    id: 'table-icon-checkmark-reverse-round-id',
  },
  dash: {
    name: 'visa-icon-dash',
    id: 'table-icon-dash-id',
  },
  cross: {
    name: 'visa-icon-close',
    id: 'table-icon-close-id',
  },
};
